module.exports = __webpack_public_path__ + "static/media/11.bcf43971.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/11.png
// module id = 1449
// module chunks = 0